import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "grid-col-sm-12" }
const _hoisted_3 = { class: "error" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "h4 alegra-color-dark mt-3 mb-4" }, "Error!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("article", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", null, _toDisplayString(_ctx.message), 1)
      ])
    ])
  ]))
}